















import { Component, Mixins } from 'vue-property-decorator'
import RecommendItem from './mixins/RecommendItem'
import { searchToWhereUrl } from '@core/utils/jump'

@Component
export default class AdvertiseItem2 extends Mixins(RecommendItem) {
  get goDetailExposure() {
    const { bid, title } = this.value
    return `200025||${JSON.stringify({ name: title, popid: bid, tabname: this.tab.tabName })}`
  }
  async goDetail() {
    const { bid, title } = this.value
    this.$newClickTracker({ ...this.pageTrackParams, clickId: '200025', positionParam: { name: title, popid: bid, tabname: this.tab.tabName } })
  }

  // get linkUrl() {
  //   const { bid } = this.value
  //   return this.kwtarget(searchToWhereUrl({ toShop: true, businessId: bid }))
  // }
}
